export enum FsmType {
  Animation = 'Animation'
}
